import { useTranslation } from "react-i18next";
import { LifeBuoy } from "lucide-react";
import { CartProvider } from "@/features/cart";
import { ShopLayout } from "@/features/shop/components/ShopLayout";
import { ContactSection } from "@/features/shop/components/ContactSection";
import { useShopCurrency } from "@/features/shop/useShopCurrency";

/**
 * Soporte: la sección que el menú del sitio promete (Anahí, 27-ago).
 *
 * No es una pantalla nueva de mentira: reutiliza el formulario de
 * contacto REAL de la tienda — el que guarda el mensaje en la base
 * antes de intentar el correo, para que ninguna pregunta se pierda.
 */
export function SoportePage() {
  return (
    <CartProvider>
      <SoporteScreen />
    </CartProvider>
  );
}

function SoporteScreen() {
  const { t } = useTranslation();
  const [currency, setCurrency] = useShopCurrency();

  return (
    <ShopLayout currency={currency} onCurrencyChange={setCurrency}>
      <div className="mx-auto w-full max-w-[900px] px-4 pt-10 sm:px-8">
        <div className="mb-2 flex items-center gap-3">
          <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-ds-violet-pop text-white">
            <LifeBuoy className="h-5 w-5" />
          </span>
          <div>
            <h1 className="text-[26px] font-semibold text-ds-ink">{t("Soporte")}</h1>
            <p className="text-[14px] text-ds-ink-3">
              {t("¿Dudas con un producto, un pedido o tu franquicia? Escríbenos.")}
            </p>
          </div>
        </div>

        <ContactSection />
      </div>
    </ShopLayout>
  );
}
